import React, { useMemo } from 'react'

import { Page, View, Text } from '@react-pdf/renderer'
import styles from '../style'

import TopBanner from '../Components/TopBanner'
import { ICensusMemberDTO } from '../../../services/quote/dto'
import tableStyles from '../Components/ServiceTable/tableStyles'
import { DateHandler } from '@angle/utils'

type ICensusPageProps = {
  census: ICensusMemberDTO[]
}

const mapTier = (familyTier: string | null) => {
  switch (familyTier) {
    case 'single':
      return 'Employee'
    case 'employee_spouse':
      return 'Employee + Spouse'
    case 'employee_children':
      return 'Employee + Child(ren)'
    case 'family':
      return 'Employee + Family'
    default:
      return null
  }
}

const Row = (props: ICensusMemberDTO & { rowIndex: number }) => {
  const { firstName, lastName, dateOfBirth, zipCode, relationship, gender, familyTier, rowIndex } = props

  return (
    <View
      style={[
        tableStyles.tableRow,
        { backgroundColor: rowIndex % 2 === 0 ? '#F8F9FA' : 'white' }
      ]}
    >
      <Text style={[tableStyles.cellText, { width: '20%' }]}>
        {firstName}
      </Text>
      <Text style={[tableStyles.cellText, { width: '20%' }]}>
        {lastName}
      </Text>
      <Text style={[tableStyles.cellText, { width: '10%', textTransform: 'capitalize' }]}>
        {relationship}
      </Text>
      <Text style={[tableStyles.cellText, { width: '10%', textTransform: 'capitalize' }]}>
        {gender}
      </Text>
      <Text style={[tableStyles.cellText, { width: '15%' }]}>
        {DateHandler.formatForClient(dateOfBirth)}
      </Text>
      <Text style={[tableStyles.cellText, { width: '10%' }]}>
        {zipCode}
      </Text>
      <Text style={[tableStyles.cellText, { width: '15%' }]}>
        {mapTier(familyTier)}
      </Text>
    </View>
  )
}

const TableHeader = () => (
  <View style={[styles.row, { marginTop: 0, paddingVertical: 4 }]}>
    <Text
      style={[
        { width: '20%' },
        styles.descriptionText,
        tableStyles.cellText
      ]}
    >
      First Name
    </Text>
    <Text
      style={[
        { width: '20%' },
        styles.descriptionText,
        tableStyles.cellText
      ]}
    >
      Last Name
    </Text>
    <Text
      style={[
        { width: '10%' },
        styles.descriptionText,
        tableStyles.cellText
      ]}
    >
      Relationship
    </Text>
    <Text
      style={[
        { width: '10%' },
        styles.descriptionText,
        tableStyles.cellText
      ]}
    >
      Gender
    </Text>
    <Text
      style={[
        { width: '15%' },
        styles.descriptionText,
        tableStyles.cellText
      ]}
    >
      Date of Birth
    </Text>
    <Text
      style={[
        { width: '10%' },
        styles.descriptionText,
        tableStyles.cellText
      ]}
    >
      Zip Code
    </Text>
    <Text
      style={[
        { width: '15%' },
        styles.descriptionText,
        tableStyles.cellText
      ]}
    >
      Tier
    </Text>
  </View>
)

const CensusPage = ({ census }: ICensusPageProps) => {
  const censusGroupedByPage = useMemo(() => {
    const pages = []
    let lastIndex = 0
    while (lastIndex < census.length) {
      pages.push(census.slice(lastIndex, lastIndex + 40))
      // Group every 40 records
      lastIndex = lastIndex + 40
    }

    return pages
  }, [census])

  return (
    <>
      {censusGroupedByPage.map((rows: ICensusMemberDTO[]) => (
        <Page>
          <TopBanner title="Census Quoted in Proposal" />
          <View style={styles.pageBody}>
            <View
              style={{
                display: 'flex',
                width: '100%'
              }}
            >
              <TableHeader />
              {rows.map((row, index) => (
                <Row
                  key={index}
                  rowIndex={index}
                  {...row}
                />
              ))}
            </View>
          </View>
        </Page>
      ))}
    </>
  )
}

export default CensusPage
